module.exports = __webpack_public_path__ + "img/arr.cfe7a89b.svg";